module.exports = __webpack_public_path__ + "img/start-charging-desktop.31d168e2.png";